!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.closeButton = this.querySelector("[data-close]"), this.init();
    }
    init() {
      "true" !== sessionStorage.getItem("announcementClosed") ? (this.classList.remove("hidden"), 
      this.closeButton && this.closeButton.addEventListener("click", this.handleClose.bind(this))) : this.hide();
    }
    handleClose() {
      this.hide(), sessionStorage.setItem("announcementClosed", "true");
    }
    hide() {
      this.classList.add("hidden", "pointer-events-none"), window.dispatchEvent(new CustomEvent("announcementBannerDismissed"));
    }
  }
  customElements.get("annoucement-banner") || customElements.define("annoucement-banner", e);
}();